<template>
  <div
    id="detailsform"
    class="
      shadow-xl
      rounded-md
      ml-16
      mx-5
      my-5
      border-2 border-blue-600
      lg:relative
    "
  >
    <div class="flex items-center justify-center h-52" v-if="loading">
      <img src="@/assets/830.svg" alt="loader" />
    </div>
    <div
      v-else
      class="
        flex flex-row
        items-center
        space-x-4
        m-5
        justify-start
        flex-wrap
        relative
      "
    >
      <div v-if="dataNotExist" class="">
        <div class="flex-col gap-5 items-center justify-center ml-60">
          <img
            src="../../assets/personal-information.png"
            class="h-40 ml-24"
            alt="No Data"
          />
          <h3 class="text-xl text-justify font-semibold font-serif">
            <span class="text-red-400">*</span> Please Fill Your Data In the
            Profile Tab.
          </h3>
        </div>
      </div>
      <div
        v-else
        class="
          flex flex-row
          items-center
          space-x-4
          m-5
          justify-start
          flex-wrap
          relative
        "
      >
        <div id="profile">
          <div class="avatar">
            <div class="mb-8 w-24 h-24 mask">
              <img src="@/assets/personal-data.png" alt="user-profile image" />
            </div>
          </div>
        </div>

        <div id="profiledata" class="flex-1 grid grid-cols-4 gap-2">
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">User Name</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="Mill Name"
              :value="data[0].mill_name"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Addess Line 1</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              :value="data[0].address1"
              placeholder="Address"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Address Line 2</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="Address"
              :value="data[0].address2"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Address Line 3</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="Address"
              :value="data[0].address3"
              class="input input-bordered input-sm"
            />
          </div>

          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">City</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="City"
              :value="data[0].city"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">State</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="State"
              :value="data[0].state"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Pincode</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="pincode"
              :value="data[0].pincode"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Installed Spindles</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="Installed Spindles"
              :value="data[0].installed_spdls"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Installed Rotors</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="Installed Rotors"
              :value="data[0].installed_rotors"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Installed-S-Looms</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="Installed S Looms"
              :value="data[0].installed_s_looms"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">Installed-SL-Looms</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="Installed-SL-Looms"
              :value="data[0].installed_sl_looms"
              class="input input-bordered input-sm"
            />
          </div>
          <div class="form-control w-full">
            <label class="label">
              <span class="label-text">GST No</span>
            </label>
            <input
              type="text"
              disabled="disabled"
              placeholder="gstno"
              :value="data[0].gstno"
              class="input input-bordered input-sm"
            />
          </div>
        </div>
      </div>
      <div class="absolute -top-7 -right-7">
        <div class="btn bg-blue-600">
          Id :
          <div class="badge ml-2 badge-lg badge-ghost relative">
            {{ id }}
            <span
              class="
                animate-ping
                absolute
                -top-5
                -right-5
                inline-flex
                h-5
                w-5
                rounded-full
                bg-yellow-400
                opacity-80
              "
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MillProfile",
  data() {
    return {
      id: sessionStorage.getItem("millId"),
      data: [],
      loading: false,
      dataNotExist: false,
    };
  },
  created() {
    this.getMillData();
  },
  methods: {
    getMillData() {
      this.loading = true;
      let jdata = JSON.stringify({
        regId: this.id,
      });
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/MillData`,
          jdata
        )
        .then((res) => {
          if (!res.data.data) {
            this.loading = false;
            this.dataNotExist = true;
          } else {
            this.data.push(res.data.data);
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err) {
            this.loading = false;
            alert("Error Getting Data");
          }
        });
    },
  },
};
</script>
